// Valuer-side semantics: the warning colour means "your move".
import { EVALUATION_LABELS } from '@wasity/shared';
import { Chip } from '@/components/ui';
import { useI18n } from '@/i18n';
import type { EV } from '@/lib/types';

export const EVALUATOR_ACTIVE = ['accepted', 'fee_set', 'in_progress', 'report_ready'] as const;

export function EvaluatorEvChip({ ev }: { ev: EV }) {
  const { t, pick } = useI18n();
  if (ev.status === 'fee_set') return <Chip form="outlined">{t('status.awaitingOwnerPayment')}</Chip>;
  if (ev.status === 'accepted' || ev.status === 'in_progress' || ev.status === 'report_ready') return <Chip form="warning">{pick(EVALUATION_LABELS[ev.status])}</Chip>;
  return <Chip form={EVALUATION_LABELS[ev.status].chip === 'warning' ? 'outlined' : EVALUATION_LABELS[ev.status].chip}>{pick(EVALUATION_LABELS[ev.status])}</Chip>;
}

export function useEvNextStep() {
  const { t } = useI18n();
  return (ev: EV): { text: string; muted?: boolean } => {
    switch (ev.status) {
      case 'assigned': return { text: t('evaluator.requests.next.acceptFirst') };
      case 'accepted': return { text: t('evaluator.requests.next.setFee') };
      case 'fee_set': return { text: t('evaluator.requests.next.awaitPayment'), muted: true };
      case 'in_progress': return { text: t('evaluator.requests.next.visit') };
      case 'report_ready': return { text: t('evaluator.requests.next.close') };
      default: return { text: '—', muted: true };
    }
  };
}
